{
	"label": "Проследимост на въглеродните редукции",
	"title": "Проследимост на въглеродните редукции",
	"paragraph": "Въглеродните редукции могат да се съхраняват сигурно в блокчейн, което осигурява прозрачност и проследимост. Използвайки блокчейн технологията, всяка транзакция за въглеродни редукции може да бъде записана и потвърдена по децентрализиран и неизменяем начин. Това позволява надеждна и подлежаща на одит система, в която намаленията на емисиите могат да бъдат точно проследявани и отчитани. Това означава, че не може да се извърши транзакция многократно за един и същ 1 въглероден кредит.",
	"close": "Затвори"
}
